const videoConfig = {
  translate: {
    youtube: { providerType: 'youtube', videoId: 'CadZpJ7AlvQ' },
    brightcove: { providerType: 'youtube', videoId: 'PexANw32ywM' },
  },
  suppressedPlayerErrors: ['The node before which the new node is to be inserted is not a child of this node'],
}

export default videoConfig
